$(document).ready(function(){

  var inc = 0;

  function detectmob() {
    if( navigator.userAgent.match(/Android/i)
    || navigator.userAgent.match(/webOS/i)
    || navigator.userAgent.match(/iPhone/i)
    || navigator.userAgent.match(/iPad/i)
    || navigator.userAgent.match(/iPod/i)
    || navigator.userAgent.match(/BlackBerry/i)
    || navigator.userAgent.match(/Windows Phone/i)
    ){
      return true;
    }
    else {
      return false;
    }
  }

  var detectmob = detectmob();
  console.log(detectmob);

  $(window).scroll( function(){

    /* Check the location of each desired element */
    $('.fade').each( function(i){

        var bottomElt = $(this).offset().top + $(this).outerHeight();
        var bottomWindow = $(window).scrollTop() + $(window).height();

        /* If the object is completely visible in the window, fade it it */
        if(!detectmob){
          if( bottomWindow+inc > bottomElt ){

              $(this).addClass('show');

          }
        }else{

          if( $(window).scrollTop()+200 > $(this).offset().top ){

              $(this).addClass('show');

          }

        }


    });

  });

  $('#dropDown p').click(function(){

    if($(this).hasClass('open')){
      $(this).removeClass('open');
    }else{
      $("#dropDown p").each(function(){
        $(this).removeClass('open')
      })
      $(this).addClass('open');
    }

  })

})



// WEBPACK FOOTER //
// ./src/js/agence.js